import React from "react";

import { Typography, TextField } from "@portex-pro/ui-components";
import { useTranslation } from "react-i18next";

interface CarrierRoutingPreferencesProps {
  value: string;
  onChange: (value: string) => void;
}

export const CarrierRoutingPreferences: React.FC<CarrierRoutingPreferencesProps> = ({ value, onChange }) => {
  const { t } = useTranslation("quoteRequest");

  return (
    <div className="space-y-2">
      <Typography variant="subtitle1" className="font-semibold">
        {t("QuotePreferencesStep.carrierRoutingPreferences")}
      </Typography>

      <TextField
        multiline
        rows={4}
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("QuotePreferencesStep.carrierRoutingPreferencesPlaceholder")}
        variant="outlined"
        className="w-full"
      />
    </div>
  );
};
